module.exports = __webpack_public_path__ + "static/post-img-2ef20d6f8faceabf5676b59ed51041e9.jpg";